'use client';

import {LogoWall} from '@shared/LogoWallRedesign/LogoWall';
import classNames from '@sindresorhus/class-names';
import {COOKIE_WEB_AUTO_DOWNLOAD, setCookie} from '@utils/cookies';
import Link from 'next/link';
import {useCallback, useRef} from 'react';

import {useEnvContext} from '@web-landing/components/EnvContext/EnvContextProvider';
import {log} from '@web-landing/components/SearchPicks/MiniPicks/analytics';

import {ym_log} from '@web-landing/page_components/instruction/analytics';

import {headerTestIds} from '@web-landing/constants/test-ids/mainLandingTestIds';

import {MainLanding} from '@strapi/types';

import {useIsMobile} from '@web-landing/hooks/useIsMobile';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {emitEcommerceSelectAppEventWithCookie} from '@web-landing/analytics/emitEcommerceSelectAppEventWithCookie';
import {EVENTS} from '@web-landing/analytics/events';

import styles from './Intro.module.scss';

type Props = {
  mainLanding: MainLanding;
};

export const Intro = ({mainLanding}: Props) => {
  const {cookieDomain} = useEnvContext();
  const isMobile = useIsMobile();
  const pixelRef = useRef<HTMLImageElement>(null);
  const openStoreClick = () => {
    log.omicronFromLandingToInstructions();
    log.landingDownloadRustoreMainClick();
    ym_log.instructionButtonCopyLinkYM();

    if (isMobile) {
      setCookie(COOKIE_WEB_AUTO_DOWNLOAD, 'true', cookieDomain || '');
    }
  };

  const handleLogoClick = useCallback((href: string, index: number) => {
    const packageName = href.split('/').pop();

    logTmrEvent(EVENTS.appSelect, {
      compilation_id: 'landing_app_compilation_PDjTe1',
      compilation_name: 'play',
      compilation_type: 'grid',
      app_packageName: packageName,
    });
    packageName &&
      emitEcommerceSelectAppEventWithCookie({
        packageName,
        cookieDomain,
        listName: 'play',
        position: index,
      });
  }, []);

  return (
    <div className={styles.initial}>
      <img
        className={styles.hiddenImg}
        ref={pixelRef}
        aria-hidden="true"
        alt="невидимый пиксель"
      />
      <div className={classNames(styles.wrapper)}>
        <h1 className={styles.title}>{mainLanding.Header} </h1>
        <div className={styles.subtitle_wrapper}>
          <p className={styles.subtitle}>{mainLanding.Subheader} </p>
          <Link
            className={styles.downloadButton}
            href={'/instruction'}
            onClick={openStoreClick}
            data-testid={headerTestIds.DownloadRustoreButton}
          >
            {mainLanding.DownloadButton ?? 'Скачать RuStore'}
          </Link>
        </div>
      </div>
      <LogoWall logoWall={mainLanding.LogoWall} onLogoClick={handleLogoClick} />
    </div>
  );
};
